import { useState } from "react";
import "./BlankForm.css";

interface Props {
  setCardHolder: (newValue: string | null) => void;
  setCardNumber: (newValue: string | null) => void;
  setMonth: (newValue: string) => void;
  setYear: (newValue: string) => void;
  setCvc: (newValue: string) => void;
  setCompleted: (newValue: boolean) => void;
  setBlank: (newValue: boolean) => void;
}

export default function Form(props: Props) {
  const [wrongNumber, setWrongNumber] = useState<boolean>(false);

  function validNumber(str: string) {
    setWrongNumber(false);
    if (str.length > 16) return;
    if (str === "") {
      props.setCardNumber(null);
      setWrongNumber(false);
    }
    if (!/^\d+$/.test(str) && str !== "") {
      setWrongNumber(true);
      return;
    }
    const validStr = str.replace(/(.{4})/g, "$1 ").trim();
    props.setCardNumber(validStr);
  }

  function setCVCnumber(num: string | null) {
    props.setBlank(false);
    if (num === "") props.setCvc(null);
    if (/^\d+$/.test(num))
      num.length > 0 ? props.setCvc(num) : props.setCvc(null);
  }

  return (
    <div className="form-container">
      <form>
        <label>
          CARDHOLDER NAME
          <input
            required
            placeholder="e.g. Jane Appleseed"
            className="info"
            onChange={(e) => {
              if (e.target.value.length < 30 && e.target.value !== "")
                props.setCardHolder(e.target.value.toUpperCase());
              if (e.target.value === "") props.setCardHolder(null);
            }}
          />
        </label>
        <label>
          CARD NUMBER
          <input
            type="text"
            required
            maxLength={16}
            placeholder="e.g. 1234 5678 1234 0000"
            className="info"
            onChange={(e) => {
              validNumber(e.target.value);
            }}
          />
          {wrongNumber ? <p>Wrong format. Numbers only</p> : ""}
        </label>
        <div className="labels">
          <label style={{ textAlign: "left" }}>EXP. DATE (MM/YY)</label>
          <label>CVC</label>
        </div>
        <div className="date">
          <input
            required
            maxLength={2}
            placeholder="MM"
            name="month"
            onChange={(e) => {
              props.setBlank(false);
              if (/^\d+$/.test(e.target.value)) props.setMonth(e.target.value);
              if (e.target.value === "" || Number(e.target.value) > 12) {
                props.setMonth(null);
                console.log(Number(e.target.value));
              }
            }}
          />
          <input
            required
            maxLength={2}
            placeholder="YY"
            onChange={(e) => {
              props.setBlank(false);
              if (/^\d+$/.test(e.target.value)) props.setYear(e.target.value);
              if (e.target.value === "") props.setYear(null);
            }}
          />

          <input
            required
            type="text"
            maxLength={4}
            placeholder="e.g. 123"
            className="cvc-input"
            onChange={(e) => {
              setCVCnumber(e.target.value);
            }}
          ></input>
        </div>
      </form>
    </div>
  );
}
